import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Unauthorized.module.css";
import { getLogisticsRole } from "../../utils/authToken";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  const loggedUserRole = getLogisticsRole();

  const goToHomePage = () => {
    navigate("/home");
  };

  return (
    <div className={styles.container}>
      {loggedUserRole == null ? (
        <>
          <h1 className={styles.title}>Sign-In Required</h1>
          <p className={styles.message}>
            You are not currently signed in to the SmartPrint application.{" "}
          </p>
          <p className={styles.message}>
            Please click <a href="/">here</a> to sign in.{" "}
          </p>
        </>
      ) : (
        <>
          {" "}
          <h1 className={styles.title}>Unauthorized Access</h1>
          <p className={styles.message}>
            You do not have permission to view this page.
          </p>
          <button className={styles.button} onClick={goToHomePage}>
            Go to Home Page
          </button>
        </>
      )}
    </div>
  );
};

export default Unauthorized;
